// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"160":"37bd6b38","265":"f76957a7","723":"7057bc5f","728":"87272f37","768":"95b48bae","874":"13a5b00c","888":"0e2b0191"}[chunkId] + ".css";
};